module.exports = __webpack_public_path__ + "img/crc-05.f53abe6d.jpg";